/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import Button from '../elements/Button';

export default function IconFooter() {
  return (
    <Button
      className=""
      type="link"
      href="/"
    >
      <img src="/assets/images/logo-small-black.png" alt="Brand Logo" style={{ height: 70 }} />
    </Button>
  );
}
